module.exports = __webpack_public_path__ + "static/media/home_wlfw.f539b45d.png";